<template>
  <div class="upload-slide-filelist">
    <rt-section :title="title" icon="rt-base-account">
      <el-upload
        slot="btn"
        :show-file-list="false"
        :http-request="uploadFile"
        class="addBtn"
        action
      >
        <rt-icon :color="iconColor" name="rt-base-plus" />
      </el-upload>
      <div class="file-list">
        <div v-for="(item, index) in list" :key="index" class="file-item">
          <div class="file-icon">
            <img
              v-if="['jpg', 'png', 'jpeg'].indexOf(fileSuffix(item.name)) > -1"
              :src="item.url"
              alt=""
            />
            <rt-icon
              v-else
              :name="fileIconName(item.name)"
              :color="fileIconColor(item.name)"
              size="28"
            />
          </div>
          <div class="file-detail">
            <p class="item-name">{{ item.name }}</p>
            <div class="uploadTime-and-operation">
              <span class="time">{{ item.uploadTime }}</span>
              <div class="operation">
                <rt-button
                  v-if="
                    ['jpg', 'png', 'jpeg'].indexOf(fileSuffix(item.name)) > -1
                  "
                  text
                  type="plain"
                  @click="previewImg(item.url)"
                  >预览</rt-button
                >
                <rt-popconfirm
                  title="确定需要删除这条内容吗？"
                  @onConfirm="onConfirm(item.name, index)"
                >
                  <rt-button slot="reference" text type="plain">删除</rt-button>
                </rt-popconfirm>
              </div>
            </div>
          </div>
        </div>
      </div>
    </rt-section>
    <el-dialog :visible.sync="imgVisible">
      <img :src="previewUrl" />
    </el-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtSection from '../section/rtSection';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';

import ossClient from '../upload/aliyun.oss.client';
import ossClientConfig from '../upload/ossClientConfig';
export default {
  name: 'RtUploadSlideFilelist',
  components: {
    RtIcon,
    RtSection,
    RtButton,
    RtPopconfirm
  },
  props: {
    title: {
      type: String,
      default: '文件列表'
    },
    iconColor: {
      type: String,
      default: '#6388C2'
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      currentIndex: 0,
      imgVisible: false,
      previewUrl: ''
    };
  },
  watch: {
    data(newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
      });
    }
  },
  methods: {
    uploadFile(file) {
      let now = new Date();
      let [month, date, hour, minute] = ['', ''];
      month = now.getMonth() + 1;
      date = now.getDate();
      hour = now.getHours();
      minute = now.getMinutes();
      console.log('file===', file);
      let fileName = file.file.name;
      let obj = {
        url: '',
        name: fileName,
        uploadTime: `${month}-${date} ${hour}:${minute}`
      };
      ossClient(ossClientConfig)
        .multipartUpload(fileName, file.file)
        .then(({ res, url, name }) => {
          if (res && res.status == 200) {
            console.log(`阿里云OSS上传图片成功回调`, res, url, name);
            let response = `http://${ossClientConfig.bucket}.${ossClientConfig.region}.aliyuncs.com/${fileName}`;
            obj.url = response;
            this.list.push(obj);
          }
        })
        .catch(err => {
          console.log(`阿里云OSS上传图片失败回调`, err);
        });
    },
    // 删除确认事件
    onConfirm(name, index) {
      ossClient(ossClientConfig)
        .delete(name)
        .then(res => {
          this.list.splice(index, 1);
        })
        .catch(err => {
          console.log('删除失败', err);
        });
    },
    previewImg(url) {
      this.imgVisible = true;
      this.previewUrl = url;
    },
    // 取文件后缀名
    fileSuffix(name) {
      return name.substring(name.lastIndexOf('.') + 1).toLowerCase();
    },
    // 根据文件后缀名显示对应的icon
    fileIconName(name) {
      let fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
      if (fileSuffix === 'mp4') {
        return 'rt-base-file-video-fill';
      } else if (fileSuffix === 'wps') {
        return 'rt-base-file-word-fill';
      } else if (fileSuffix === 'ppt') {
        return 'rt-base-file-ppt-fill';
      } else {
        return 'rt-base-file-unknown-fill';
      }
    },
    // 根据文件后缀名显示对应的颜色值
    fileIconColor(name) {
      let fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
      if (fileSuffix === 'mp4') {
        return '#55ceb3';
      } else if (fileSuffix === 'wps') {
        return '#53a4fc';
      } else if (fileSuffix === 'ppt') {
        return '#f7a959';
      } else {
        return '#f5f7fa';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtUploadSlideFile.vue?21838e63